import * as React from "react";
import PropTypes from 'prop-types';

const SvgBackArrow = props => {
  if (props.id !== "_svgbackarrow") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M26.044 17.236a1.2 1.2 0 100-2.4H8.92l7.239-7.24a1.196 1.196 0 00-1.691-1.69L5.24 15.133a1.22 1.22 0 00-.097.109 1.196 1.196 0 00.072 1.662c.032.04.067.078.104.116l8.988 8.987c.533.533 1.345.586 1.813.117.469-.468.416-1.28-.117-1.813l-7.076-7.075h17.116z" fill="#0077C5" /></svg>;
};

SvgBackArrow.displayName = "_svgbackarrow";
SvgBackArrow.propTypes = {
  id: PropTypes.string
};
SvgBackArrow.defaultProps = {
  id: ''
};
export default SvgBackArrow;